import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').ChatDataReducer,
 *   ui: import('./ui').ChatUIReducer,
 * }} ChatReducer
 */

export default combineReducers({
  data,
  ui,
});
